<template>
  <vue-apex-charts
    ref="chart"
    type="line"
    height="400"
    :options="chartOptions"
    :series="series"
  />
</template>
<script setup>
import VueApexCharts from 'vue-apexcharts'
import { ref, nextTick, onMounted, computed, toRefs, watch } from 'vue'
import themeConfig from '@themeConfig'

const chart = ref(null)

const props = defineProps({
  data: {
    type: Array,
    default: () => [280, 200, 220, 180, 270, 250, 70, 90, 200, 150, 160, 100, 150, 100, 50],
  },
  data2: {
    type: Array,
    default: () => [],
  },
  max: {
    type: Number,
    default() {
      return null
    },
  },
  categories: {
    type: Array,
    default: () => [
      '7/12',
      '8/12',
      '9/12',
      '10/12',
      '11/12',
      '12/12',
      '13/12',
      '14/12',
      '15/12',
      '16/12',
      '17/12',
      '18/12',
      '19/12',
      '20/12',
      '21/12'],
  },
  legend: {
    type: String,
    default: () => 'a',
  },
  xAxis: {
    type: Object,
    default() {
      return null
    },
  },
  yAxis: {
    type: Object,
    default() {
      return null
    },
  },
  color: {
    type: String,
    default: () => '',
  },

  // yTickAmount: {
  //   type: Number,
  //   default: 0,
  // },
  // yLabelFormatter: {
  //   type: Function,
  //   default() {
  //     return null
  //   },
  // },
})
const { data, data2, categories, legend, yAxis, xAxis, color } = toRefs(props)

let $themeColors = themeConfig.themes.light.primary

if (color.value) {
  $themeColors = color.value
}
const option = {
  chart: {
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
  },
  legend: {
    customLegendItems: [legend.value],
    showForSingleSeries: !!(legend.value),
  },
  markers: {
    strokeWidth: 7,
    strokeOpacity: 1,
    strokeColors: [$themeColors.secondary],
    colors: [$themeColors],
  },
  colors: [$themeColors, $themeColors.primary],
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
  },
  grid: {
    xaxis: {
      lines: {
        show: true,
      },
    },
  },
  tooltip: {
    custom(item) {
      return `${'<div class="px-1 py-50"><span>'}${
        item.series[item.seriesIndex][item.dataPointIndex]
      }</span></div>`
    },
  },
  xaxis: {
    categories: categories.value,
  },
}

// if (max.value) {
//   option.yaxis.max = max.value
// }
// if (yTickAmount.value) {
//   option.yaxis.tickAmount = yTickAmount.value
// }
// if (yLabelFormatter.value) {
//   option.yaxis.labels.formatter = yLabelFormatter.value
// }

if (yAxis.value) {
  option.yaxis = [{ ...yAxis.value }]
}

if (xAxis.value) {
  option.xaxis = { ...option.xaxis, ...xAxis.value }
}
const series = ref([
  {
    data: data.value,
  },
])
watch(data, newData => {
  // console.log('update data', newData)
  series.value[0].data = [...newData]
})

// if (data2.value && data2.value.length > 0) {
//   series.value[1] = { data: data2.value }
//   option.yaxis[1] = { ...yAxis.value }
// }
// watch(data2, newData => {
//   console.log('update data2', newData)
//   series.value[1].data = [...newData]
// })

const chartOptions = ref({ ...option })
function refresh() {
  // console.log('render', chart.value)
  if (chart.value) {
    chart.value.refresh()
  }
}

defineExpose({ refresh })
</script>
<style setup>

</style>
